import { TGetWishlistSuggestions } from '@daymade/api-contracts';
import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { YourWishlist } from 'components/dashboard/your-wishlist/YourWishlist';
import RoundedButton from 'components/RoundedButton';
import { useState } from 'react';
import { TWishlistPrize } from 'stores/UserStore';
import { DaymadeDesignSystemPreviewComponentInfo } from '../';

const wishlistPrize = (id: number, title: string): TWishlistPrize =>
  ({
    id,
    title,
    heroImageLocation: `https://picsum.photos/seed/wishlist-${id}/900/600`,
  }) as TWishlistPrize;

const suggestedPrize = (
  id: number,
  title: string,
): TGetWishlistSuggestions[number] =>
  ({
    id,
    title,
    heroImageLocation: `https://picsum.photos/seed/suggested-${id}/900/600`,
  }) as TGetWishlistSuggestions[number];

const noOpAsync = async () => {};

const emptyWishlist: TWishlistPrize[] = [];
const oneWishlistItem: TWishlistPrize[] = [
  wishlistPrize(1, 'Dream city break'),
];
const manyWishlistItems: TWishlistPrize[] = [
  wishlistPrize(2, 'Sports car weekend'),
  wishlistPrize(3, 'Private dining experience'),
  wishlistPrize(4, 'Smart home makeover'),
  wishlistPrize(5, 'Luxury mountain cabin'),
];

const suggestedPrizes: TGetWishlistSuggestions = [
  suggestedPrize(101, 'Scandinavian getaway'),
  suggestedPrize(102, 'Ultimate gaming room setup'),
];

const singleSuggestedPrize: TGetWishlistSuggestions = [
  suggestedPrize(103, 'Designer wardrobe refresh'),
];

const ComponentPreview = () => {
  const [previewSelectedPrize, setPreviewSelectedPrize] =
    useState<TWishlistPrize>();

  return (
    <AboutUsModule background="white">
      <AboutUsSiteContainer>
        <h3 className="aboutUsTypographyHeaderLarge">Your wishlist</h3>
        <p>
          Presentational version of the dashboard wishlist component. These
          examples show common UI states while keeping store logic outside this
          component.
        </p>

        <h4 className="aboutUsTypographyHeaderMedium">Empty wishlist</h4>
        <p>Shows the empty slot plus suggested prizes.</p>
        <div style={{ maxWidth: 460, marginBottom: 24 }}>
          <YourWishlist
            fullWishlist={emptyWishlist}
            shortlistSuggestedPrizes={suggestedPrizes}
            selectedPrize={undefined}
            openUnfavouritePrizeModal={() => undefined}
            unfavouritePrize={noOpAsync}
            favouritePrize={noOpAsync}
            closeModal={() => undefined}
            desktopPrizesDirection="column"
          />
        </div>

        <h4 className="aboutUsTypographyHeaderMedium">One wishlist item</h4>
        <p>Shows one favourited prize and one suggested card.</p>
        <div style={{ maxWidth: 460, marginBottom: 24 }}>
          <YourWishlist
            fullWishlist={oneWishlistItem}
            shortlistSuggestedPrizes={singleSuggestedPrize}
            selectedPrize={undefined}
            openUnfavouritePrizeModal={() => undefined}
            unfavouritePrize={noOpAsync}
            favouritePrize={noOpAsync}
            closeModal={() => undefined}
            desktopPrizesDirection="column"
          />
        </div>

        <h4 className="aboutUsTypographyHeaderMedium">Many wishlist items</h4>
        <p>Shows three cards and the View all link path.</p>
        <div style={{ maxWidth: 460, marginBottom: 24 }}>
          <YourWishlist
            fullWishlist={manyWishlistItems}
            shortlistSuggestedPrizes={[]}
            selectedPrize={undefined}
            openUnfavouritePrizeModal={() => undefined}
            unfavouritePrize={noOpAsync}
            favouritePrize={noOpAsync}
            closeModal={() => undefined}
            desktopPrizesDirection="column"
          />
        </div>

        <h4 className="aboutUsTypographyHeaderMedium">Unfavourite modal</h4>
        <p>Use the button or a heart icon to open it.</p>
        <p style={{ marginBottom: 12 }}>
          <RoundedButton
            mini
            rebrandDm2025
            onClick={() => setPreviewSelectedPrize(manyWishlistItems[0])}
          >
            Open unfavourite modal
          </RoundedButton>
        </p>
        <div style={{ maxWidth: 460 }}>
          <YourWishlist
            fullWishlist={manyWishlistItems}
            shortlistSuggestedPrizes={[]}
            selectedPrize={previewSelectedPrize}
            openUnfavouritePrizeModal={(prize) =>
              setPreviewSelectedPrize(prize)
            }
            unfavouritePrize={async () => {
              setPreviewSelectedPrize(undefined);
            }}
            favouritePrize={noOpAsync}
            closeModal={() => setPreviewSelectedPrize(undefined)}
            desktopPrizesDirection="column"
          />
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Your Wishlist',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
